/**
 * DateTime formats for VueI18n. On these, the locale fallbacks apparently only apply
 * within the base language (e.g. 'en' or 'es'). Maybe a bug in VueI18n. So we must
 * repeatedly define the 'es' formats as well. All English locales successfully fallback
 * to the 'en' definitions. These must match the options available in the
 * Intl.DateTimeFormat constructor.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#parameters
 */
const datetimeFormats = {
  en: {
    hour12: {
      hour: 'numeric',
      hour12: true
    },
    hourMinuteDigits: {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    },
    hourMinuteDigits24: {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    },
    shortTime: {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    },
    shortWeekdayShortTime: {
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    },
    weekdayMonthDay: {
      weekday: 'long',
      month: 'short',
      day: 'numeric'
    },
    monthDay: {
      month: 'short',
      day: 'numeric'
    },
    shortDate: {
      month: 'numeric',
      day: 'numeric',
      year: 'numeric'
    },
    short: {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    },
    date: {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    },
    dateTime: {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    },
    mediumDate: {
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    },
    medium: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    },
    mediumLongDate: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short'
    },
    longDate: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long'
    },
    shortLong: {
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    },
    mediumLong: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    },
    extraLong: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true
    },
    timestamp: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    },
    weekday: {
      weekday: 'short'
    },
    month: {
      month: 'short'
    },
    day: {
      day: 'numeric'
    },
    year: {
      year: 'numeric'
    }
  },
  'en-NZ': {
    shortDate: {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric'
    },
    date: {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    }
  },
  'en-AU': {
    shortDate: {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric'
    },
    date: {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    }
  },
  'en-GB': {
    shortDate: {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric'
    },
    date: {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    }
  },
  'en-IE': {
    shortDate: {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric'
    },
    date: {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    }
  }
}
datetimeFormats.es = _.cloneDeep(datetimeFormats.en)
datetimeFormats['es-PR'] = _.cloneDeep(datetimeFormats.en)
datetimeFormats['es-US'] = _.cloneDeep(datetimeFormats.en)
datetimeFormats['es-ES'] = _.cloneDeep(datetimeFormats.en)
datetimeFormats['es-DO'] = _.cloneDeep(datetimeFormats.en)
datetimeFormats['es-GT'] = _.cloneDeep(datetimeFormats.en)
datetimeFormats['es-PA'] = _.cloneDeep(datetimeFormats.en)
export default datetimeFormats
